import React from 'react';

// Global brand footer used across the app.
// `compact` renders a single inline line for auth/marketing screens.
// Default renders two stacked lines for the in-app shell.
export default function Footer({ compact = false, className = '' }) {
	if (compact) {
		return (
			<div className={`text-xs text-slate-500 text-center ${className}`} data-testid="app-footer">
				© 2026 <span className="font-semibold">RamRath Global (GA)</span>. All Rights Reserved.
				<span className="mx-2 text-slate-300">·</span>
				Concept, Framework, Product Vision &amp; Design by <span className="font-semibold">Giridhar Alwar</span>
			</div>
		);
	}
	return (
		<footer
			className={`mt-12 pt-6 pb-8 border-t border-slate-200 text-center ${className}`}
			data-testid="app-footer"
		>
			<div className="text-xs text-slate-500">
				Copyright © 2026 <span className="font-semibold text-slate-700">RamRath Global (GA)</span>. All Rights Reserved.
			</div>
			<div className="mt-1 text-xs text-slate-400">
				Concept, Framework, Product Vision &amp; Design by <span className="font-semibold text-slate-600">Giridhar Alwar</span>
			</div>
		</footer>
	);
}
